module.exports = __webpack_public_path__ + "static/media/logo-ism.334d254b.jpg";